import React, { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { SectionCard } from './SectionCard';
import { Save, Loader2 } from 'lucide-react';

const FIELDS = [
  { key: 'home_h1', label: 'Home — Main Heading (H1)' },
  { key: 'home_subtitle', label: 'Home — Subtitle (below H1)', textarea: true },
  { key: 'home_welcome_title', label: 'Home — Welcome Section Title' },
  { key: 'home_welcome_p1', label: 'Home — Welcome Paragraph 1', textarea: true },
  { key: 'home_welcome_p2', label: 'Home — Welcome Paragraph 2', textarea: true },
  { key: 'cta_title', label: 'CTA Banner Title' },
  { key: 'cta_text', label: 'CTA Banner Description', textarea: true },
  { key: '__divider_about', label: '— About Page —' },
  { key: 'page_about_title', label: 'About Page — Banner Title' },
  { key: 'about_subtitle', label: 'About Page — Subtitle (e.g. "Our Story")' },
  { key: 'about_heading', label: 'About Page — Main Heading' },
  { key: 'about_p1', label: 'About Page — Paragraph 1', textarea: true },
  { key: 'about_p2', label: 'About Page — Paragraph 2', textarea: true },
  { key: 'about_p3', label: 'About Page — Paragraph 3', textarea: true },
  { key: 'about_feature_1_title', label: 'About — Feature 1 Title' },
  { key: 'about_feature_1_desc', label: 'About — Feature 1 Description', textarea: true },
  { key: 'about_feature_2_title', label: 'About — Feature 2 Title' },
  { key: 'about_feature_2_desc', label: 'About — Feature 2 Description', textarea: true },
  { key: 'about_feature_3_title', label: 'About — Feature 3 Title' },
  { key: 'about_feature_3_desc', label: 'About — Feature 3 Description', textarea: true },
  { key: 'about_feature_4_title', label: 'About — Feature 4 Title' },
  { key: 'about_feature_4_desc', label: 'About — Feature 4 Description', textarea: true },
  { key: '__divider_other', label: '— Other Pages —' },
  { key: 'page_products_title', label: 'Products Page — Banner Title' },
  { key: 'page_gallery_title', label: 'Gallery Page — Banner Title' },
  { key: 'page_contact_title', label: 'Contact Page — Banner Title' },
  { key: '__divider_footer', label: '— Footer —' },
  { key: 'footer_about_text', label: 'Footer — About Text', textarea: true },
  { key: 'footer_copyright_suffix', label: 'Footer — Copyright suffix line' },
];

export default function SiteContentManager({ onSaved, toast }) {
  const [data, setData] = useState(null);
  useEffect(() => { (async () => { try { const r = await api.get('/admin/site-content'); setData(r.data || {}); } catch { /* ignore */ } })(); }, []);

  if (!data) return <SectionCard title="Page Content"><Loader2 className="w-6 h-6 animate-spin mx-auto text-[#f7941e]" /></SectionCard>;

  const save = async () => {
    try {
      const payload = { ...data };
      delete payload._id; delete payload._singleton;
      await api.put('/admin/site-content', payload);
      toast({ title: 'Content saved' });
      onSaved && onSaved();
    } catch (err) {
      toast({ title: 'Failed', variant: 'destructive' });
    }
  };

  return (
    <SectionCard title="Page Content" subtitle="Edit text shown across the website" action={<button data-testid="save-content-btn" onClick={save} className="btn-brand text-sm"><Save className="w-4 h-4" /> Save</button>}>
      <div className="space-y-3">
        {FIELDS.map(f => (
          f.key.startsWith('__divider') ? (
            <div key={f.key} className="pt-3 pb-1 border-t border-gray-200 first:border-t-0 first:pt-0">
              <p className="font-display text-xs uppercase tracking-[3px] text-[#f7941e]">{f.label}</p>
            </div>
          ) : (
            <div key={f.key}>
              <Label>{f.label}</Label>
              {f.textarea
                ? <Textarea rows={3} value={data[f.key] || ''} onChange={e => setData({ ...data, [f.key]: e.target.value })} />
                : <Input value={data[f.key] || ''} onChange={e => setData({ ...data, [f.key]: e.target.value })} />}
            </div>
          )
        ))}
        <button onClick={save} className="btn-brand"><Save className="w-4 h-4" /> Save Content</button>
      </div>
    </SectionCard>
  );
}
